import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import TrafficlightButtonOrange from "../../../../../../../components/Button/TrafficlightButtonOrange";
import { TextMonoSignal } from "./TextMonoSignal";

export default function Dia_Mono_Signal() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
<IconButton onClick={handleOpen}>
            <TrafficlightButtonOrange />
        </IconButton>

<CustomDialog open={open} onClose={handleClose}

    title='Obesity Genes - Analysis'

    content={ <TextMonoSignal />}

/>

</>
)}